import { useService } from '../../cms/hooks'
import {Content} from '../../cms/widget'

export const App = () => {
	const {setLocale} = useService('Misc')
	if (localStorage.getItem('locale') === null)
		setLocale('en')
	return <Content />
}